module.exports = __webpack_public_path__ + "img/549-42dfb3.png";